import { plugin, Mode } from 'light-component';
import { useTranslation } from '../../../i18n';
import { WidgetType, WidgetKind } from '../types';
import { Thumbnail } from '../../component';
import { InputDesignMode } from './design';
import { InputInputMode } from './input';
import { InputViewMode } from './view';
import type { ReactElement } from 'react';
import type { InputProps } from './types';

export function BlankInput(props: InputProps): ReactElement | null {
  const [t] = useTranslation();

  if (props.mode === Mode.THUMBNAIL) {
    return (<Thumbnail icon='ShotEyesBlankInputIcon' title={t('ShotEyesBlankInput')} toolTipContent={t('填空题')} />);
  }

  if (props.mode === Mode.DESIGN) {
    return (<InputDesignMode {...props} initTitle={t('ShotEyesBlankInput')} />);
  }

  if (props.mode === Mode.VIEW) {
    return (<InputViewMode {...props} />);
  }

  if (props.mode === Mode.INPUT) {
    return (<InputInputMode {...props} />);
  }

  return null;
}

BlankInput.prototype.type = WidgetType.SHOTEYES_BLANK_INPUT;
plugin.register({ kind: WidgetKind.WIDGET, component: BlankInput });
